import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { Editor } from '../StrokeIcons';

/**
 * Extracts plain text from HTML content.
 */
function getTextFromHtml(html: string): string {
  if (html === '<p><br></p>') return '';
  if (html === '<div><br></div>') return '';
  const newHtml = html?.replace(/<br\s*\/?>/gm, '\n');
  const parser = new DOMParser();
  const document = parser.parseFromString(newHtml, 'text/html');
  return document.body.textContent?.replace(/[^\x20-\x7E]+/g, '') || '';
}

export type CGLeafCountPureProps = ComponentProps<'div'> & {
  body2: string;
  hasSalesNav?: boolean | null;
};

export function CGLeafCountPure({ body2, hasSalesNav, className, ...props }: CGLeafCountPureProps) {
  const charCount = getTextFromHtml(body2)?.length ?? 0;
  const charWarning = hasSalesNav ? charCount > 300 : charCount > 200;
  const charError = hasSalesNav ? charCount > 400 : charCount > 300;

  return (
    <div
      className={cn(
        'flex justify-end px-2 py-1 text-xs',
        'bg-white text-stone-800 dark:bg-slate-900 dark:text-stone-200',
        charWarning && 'bg-quarter-spanish-white-100 text-quarter-spanish-white-600',
        charError && 'bg-fair-pink-100 text-fair-pink-600',
        className,
      )}
      {...props}>
      {charWarning && (
        <span>
          You might exceed linkedin connect <strong>{hasSalesNav ? 300 : 200}</strong> character limit
        </span>
      )}
      <div className="grow" />
      <div className="flex items-center gap-0.5">
        <strong className="font-medium">{charCount}</strong>
        <Editor.Type01 className="size-3" />
      </div>
    </div>
  );
}
